import { Navigate, Outlet } from 'react-router';
import { getToken } from '../../utils/Sessions.jsx';
import Body from '../../components/Body.jsx';

const Layout = () => {
  const token = !!getToken();

  return token ? (
    <Body>
      <Outlet />
    </Body>
  ) : (
    <Navigate to="/login" />
  );
};

export default Layout;
